import { FlagSortOrder } from './constants';

export const initialFlagSortOrder = () => FlagSortOrder.NEWEST_FIRST;
